import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SetCloudPassword } from 'src/app/models/SetCloudPassword.model';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { userType } from 'src/app/models/user-type.model';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpService) { }

  forgotPassword(email: string) {
    return this.http.post<string>(environment.api.routes.forgot_password, { email })
  }

  resetpassword(password: string, code: string, oldPassword: string | null) {
    return this.http.post<string>(environment.api.routes.reset_password, {password, code, oldPassword})
  }

  setCloudPassword(setPassword: SetCloudPassword): Observable<string> {
    return this.http.post(environment.api.routes.set_cloud_password, setPassword)
  }

  validateEmail(email: string): Observable<userType> {
    return this.http.get<userType>(environment.api.routes.check_email_exists, { email })
  }

  is_reset_link_expired(code: string) {
    return this.http.get<boolean>(environment.api.routes.check_link, {code})
  }

  hasMultipleSubscriptions(email: string): Observable<any> {
    return this.http.get<any>(environment.api.routes.has_multiple_subscriptions, { email }).pipe(
      catchError(error => this.handleError(error))
    );
  }

  handleError(error: HttpErrorResponse): Observable<any> {
    return throwError(error.error);
  }

  checkEmailExists(email: string) {
    return this.http.get<userType>(environment.api.routes.check_email_exists, { email });
  }
}
